import axios from "@/plugins/axios";

let url = "/api/console/companies";

export default {
    getCompanies(data){
        return axios.get(url, data).then(result => result.data);
    },
    putCompany(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
}
